import { useIsAuthenticated } from "@azure/msal-react";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getEnvironment } from "../../helpers/GlobalHelper";
import { getSite } from "../../helpers/PermissionHelper";
import BPGetMyRate from "../broker/BPGetMyRate";
import { Environments, Sites } from "../constants/GlobalConstants";

const SeeOurRates = ({ ...props }) => {
  const isAuthenticated = useIsAuthenticated();
  const history = useHistory();
  useEffect(() => {
    if (getSite() !== Sites.Hosts.BUILDERS_CAPITAL_SYL) {
      let environmentUrl = `-${getEnvironment().toLocaleLowerCase()}`;
      if (getEnvironment() === Environments.PRODUCTION) {
        environmentUrl = "";
      }
      
      window.location.href = `https://${Sites.Hosts.BUILDERS_CAPITAL_SYL}${environmentUrl}.com/see-our-rates`;      
    }
    else if (isAuthenticated) {
      history.push("/");
    }
  }, []);

  return (
    <React.Fragment>
      <BPGetMyRate 
        isGreaterThanMobile={props.isGreaterThanMobile}
        isGreaterThanTablet={props.isGreaterThanTablet}
        isSidebar={props.isSidebar}
        isMessage={props.isMessage}
        setIsMessage={props.setIsMessage}
        errorResponse={props.errorResponse}
        setErrorResponse={props.setErrorResponse}
        proxyUser={props.proxyUser}
        permissions={props.permissions}
        gmrId={null}
        brokerColor={props.brokerColor}
        setGmrEditData={props.setGmrEditData}
        copiedGmrId={props.copiedGmrId}
        isPricingStartScenarios={props.isPricingStartScenarios}
        setIsPricingStartScenarios={props.setIsPricingStartScenarios}
        user={props.user}
      />
    </React.Fragment>
  );
};

export default SeeOurRates;